import { Box, Checkbox, Grid, InputLabel, Typography } from "@mui/material";
import { EnhancedCheckboxRHF, EnhancedDropDownRHFWithLabel, LabelPosition } from "@websential/cosmic";
import React, { useEffect, useState } from "react";

import { IAppState } from "../../store/reducers";
import { RHookFormNumericFormatTextField } from "./RHookFormNumericFormatTextField";
import { RHookFormTextField } from "./RHookFormTextField";
import { checkboxDefaultSelect } from "../../components/T4Slip";
import { selectedPOE } from "../../components/T4Slip/T4SlipSetup/Panels";
import { useSelector } from "react-redux";

// import { RHookFormTextField } from "@websential/cosmic";

export interface ITaxSlipDataInput {
  id: string;
  label: string;
  boxNumber: string;
  showAdjustedInput?: boolean;
  onChange?: any;
  value?: string | number | any;
  checkBox?: boolean;
  tag?: string;
  readOnly?: boolean;
  defaultValue?: string;
  globalVariablesData?: any;
  formMethods?: any;
  ddlField?: boolean;
  requiredDDL?: any;
  ddlFieldItems?: any;
  textfield?: any;
  T4SlipRecord?: any;
}

export const TaxSlipDataInput: React.FC<ITaxSlipDataInput> = ({
  id,
  label,
  boxNumber,
  showAdjustedInput = true,
  onChange,
  value,
  checkBox,
  tag,
  readOnly,
  defaultValue,
  globalVariablesData,
  formMethods,
  ddlField,
  requiredDDL,
  ddlFieldItems,
  textfield,
  T4SlipRecord
}) => {

  const [readOnlyy, setReadOnly] = useState(readOnly);
  const [eiReadOnlyy, setEiReadOnly] = useState(readOnly);
  const [cppReadOnlyy, setCppReadOnly] = useState(readOnly);
  const [checkbox, setCheckbox] = useState(false);

  const taxYear = useSelector((state: IAppState) => state.taxYear.year)

  const onSelectionChangeHandler = (value: boolean, tag?: string) => {
    // alert(value)
    // alert(tag)

    const cppQppExempt = formMethods.getValues('cppQppExempt')
    const eiExempt = formMethods.getValues('eiExempt')
    setCheckbox(value)
    if (tag === "ei") {
      if (value === true) {
        setEiReadOnly(false);
      }
      if (value === false) {
        const employmentIncome = formMethods && formMethods.getValues('employmentIncome')

        if (selectedPOE !== "" || "Quebec") {
          //     if(cppQppExempt !== true){
          //     formMethods.setValue('cppQppPensionableEarnings',Math.min(Number(employmentIncome), globalVariablesData && globalVariablesData?.t4?.cppSettingsTotalCppPensionableEarningsMaximum).toString())
          //   } else {
          //     formMethods.setValue('cppQppPensionableEarnings',"0.00")
          //   }
          if (eiExempt !== true) {
            formMethods.setValue('eiInsurableEarnings', parseFloat(Math.min(parseFloat(employmentIncome.replace(/[$,]/g, '')), globalVariablesData && globalVariablesData?.t4?.eiSettingsTotalEiEarningsMaximum).toString()).toFixed(2))
          } else {
            formMethods.setValue('eiInsurableEarnings', "0.00")
          }
        }
        if (selectedPOE === "Quebec") {
          //     if(cppQppExempt !== true){
          //     formMethods.setValue('cppQppPensionableEarnings',Math.min(Number(employmentIncome), globalVariablesData && globalVariablesData?.rl1?.qppSettingsTotalQppPensionableEarningsMaximum).toString())
          //   } else {
          //     formMethods.setValue('cppQppPensionableEarnings',"0.00")
          //   }
          if (eiExempt !== true) {
            formMethods.setValue('eiInsurableEarnings', parseFloat(Math.min(parseFloat(employmentIncome.replace(/[$,]/g, '')), globalVariablesData && globalVariablesData?.rl1?.eiSettingsQubecTotalEiEarningsMaximum).toString()).toFixed(2))
          } else {
            formMethods.setValue('eiInsurableEarnings', "0.00")
          }
        }
        setEiReadOnly(true);
      }
    } else if (tag === "cpp") {
      if (value === true) {
        setCppReadOnly(false);
      }
      if (value === false) {
        const employmentIncome = formMethods && formMethods.getValues('employmentIncome')
        if (selectedPOE !== "" || "Quebec") {
          if (cppQppExempt !== true) {

            if (taxYear > 2023) {
              formMethods.setValue('cppQppPensionableEarnings', parseFloat(Math.min(parseFloat(employmentIncome.replace(/[$,]/g, '')), globalVariablesData && globalVariablesData?.t4?.cppSettingsTotalSecondCppPensionableEarningsMaximum).toString()).toFixed(2))
            } else {
              formMethods.setValue('cppQppPensionableEarnings', parseFloat(Math.min(parseFloat(employmentIncome.replace(/[$,]/g, '')), globalVariablesData && globalVariablesData?.t4?.cppSettingsTotalCppPensionableEarningsMaximum).toString()).toFixed(2))
            }
          } else {

          }
          //   if(eiExempt !== true){
          //     formMethods.setValue('eiInsurableEarnings',Math.min(Number(employmentIncome), globalVariablesData && globalVariablesData?.t4?.eiSettingsTotalEiEarningsMaximum).toString())
          //   } else {
          //     formMethods.setValue('eiInsurableEarnings',"0.00")
          //   }
        }
        if (selectedPOE === "Quebec") {
          if (cppQppExempt !== true) {
            formMethods.setValue('cppQppPensionableEarnings', parseFloat(Math.min(parseFloat(employmentIncome.replace(/[$,]/g, '')), globalVariablesData && globalVariablesData?.rl1?.qppSettingsTotalQppPensionableEarningsMaximum).toString()).toFixed(2))
          } else {
            formMethods.setValue('cppQppPensionableEarnings', "0.00")
          }
          //   if(eiExempt !== true){
          //     formMethods.setValue('eiInsurableEarnings',Math.min(Number(employmentIncome), globalVariablesData && globalVariablesData?.rl1?.eiSettingsQubecTotalEiEarningsMaximum).toString())
          //   }else {
          //     formMethods.setValue('eiInsurableEarnings',"0.00")
          //   }
        }
        setCppReadOnly(true);
      }
    }
  };
  useEffect(() => {
    if (checkboxDefaultSelect === true) {
      setCheckbox(checkboxDefaultSelect)
    }
  }, [checkboxDefaultSelect])

  useEffect(() => {
    if (T4SlipRecord) {
      let eiInsurableEarnings = T4SlipRecord && T4SlipRecord.slipData.eiInsurableEarnings
      let employmentIncome = T4SlipRecord && T4SlipRecord.slipData.employmentIncome
      let cppQppPensionableEarnings = T4SlipRecord && T4SlipRecord.slipData.cppQppPensionableEarnings

      if (Number(employmentIncome) !== Number(eiInsurableEarnings)) {
        // alert(99)
        formMethods.setValue("checkbox-eiInsurableEarnings", true);
        // formMethods.setValue("employmentIncome", employmentIncome);
      }
      if (Number(employmentIncome) !== Number(cppQppPensionableEarnings)) {
        // alert(100)
        formMethods.setValue("checkbox-cppQppPensionableEarnings", true);
      }
    }
  }, [T4SlipRecord])

  const eiInsurableEarningsChcekbox = formMethods && formMethods.getValues('"checkbox-eiInsurableEarnings"')
  const cppQppPensionableEarningsCheckbox = formMethods && formMethods.getValues('"checkbox-cppQppPensionableEarnings"')
  useEffect(() => {
    if (eiInsurableEarningsChcekbox) {
      setEiReadOnly(false)
    } else {
      setEiReadOnly(true)
    }
    if (cppQppPensionableEarningsCheckbox) {
      setCppReadOnly(false)
    } else {
      setCppReadOnly(true)
    }
  }, [eiInsurableEarningsChcekbox, cppQppPensionableEarningsCheckbox])

  return (
    <Grid container columnSpacing={2} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
      {ddlField ?
        <><Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          sx={{
            // paddingLeft:"16px",
            "& .MuiGrid-grid-xs-7": { paddingLeft: "48px" }
          }}
        >
          <EnhancedDropDownRHFWithLabel
            selectName={id}
            label={label}
            labelPosition={LabelPosition.Left}
            testId={`consolidated-indicator-list`}
            items={ddlFieldItems ? ddlFieldItems : []}
            labelColumns={5}
            fieldColumns={7}
            required={requiredDDL}
          />
        </Grid></> :
        <><Grid
          size={{ xs: 5, sm: 5, md: 5, lg: 5, xl: 5 }}
          sx={{ textAlign: "left", paddingTop: 2 }}
        >
          <InputLabel sx={{ display: "flex" }}>
            <Typography variant="subtitle2">{label}</Typography>
            {checkBox === true ? (
              // <Checkbox
              //   sx={{ p: 0, ml: "5px" }}
              //   onChange={(e: any) => onSelectionChangeHandler(e.target.checked, tag)}
              //   checked={checkbox}
              // />
              <Box sx={{ "& .MuiFormControlLabel-root": { marginLeft: "4px" }, "& .MuiCheckbox-root": { padding: 0 } }}>

                <EnhancedCheckboxRHF
                  // sx={{ p: 0, ml: "5px" }}
                  // onChange={(e: any) => onSelectionChangeHandler(e.target.checked, tag)}
                  checked={checkbox}
                  testId={"checkbox"}
                  name={`checkbox-${id}`}
                  onSelectionChangeHandler={(e: any) => onSelectionChangeHandler(e, tag)}
                />
              </Box>
            ) : undefined}
          </InputLabel>
        </Grid>

          <Grid
            size={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}
            sx={{ textAlign: "right", paddingTop: 2 }}
          >
            <InputLabel>
              <Typography variant="subtitle2">{boxNumber}</Typography>
            </InputLabel>
          </Grid>

          <Grid size={{ xs: 3, sm: 3, md: 3, lg: 3, xl: 3 }}>
            {/* <RHookFormTextField id={`${id}_actual`} testId={`${id}-1`} /> */}
            {textfield ?
              <RHookFormTextField
                id={id}
                testId={`${id}`}
                onChange={onChange}
                value={value}
                defaultValue={defaultValue}
                readOnly={id === 'eiInsurableEarnings' ? eiReadOnlyy : id === 'cppQppPensionableEarnings' ? cppReadOnlyy : readOnly}
                textAlign={'end'}
              /> :
              <RHookFormNumericFormatTextField
                id={id}
                testId={`${id}`}
                onChange={onChange}
                value={value}
                defaultValue={defaultValue}
                readOnly={id === 'eiInsurableEarnings' ? eiReadOnlyy : id === 'cppQppPensionableEarnings' ? cppReadOnlyy : readOnly}
                textAlign={'end'}
              />
            }
          </Grid>
          <Grid size={{ xs: 3, sm: 3, md: 3, lg: 3, xl: 3 }}>
            {showAdjustedInput && (
              <RHookFormNumericFormatTextField
                // id={`${id}_adjusted`}
                id={`${id}Adjusted`}
                testId={`${id}Adjusted`}
                readOnly
                defaultValue="0.00"
                textAlign={'end'}
              />
            )}
          </Grid></>}
    </Grid>
  );
};
